import React from 'react';
import PropTypes from 'prop-types';

import './custom_radio_button.css';

// PROD-7828 M4: role=radio + keyboard activation (Space/Enter), so a mouse-only div works for keyboard
// and screen-reader users too. Callers wrap a set of these in a role="radiogroup" with a group label.
function RadioButton(props) {
  const { selected, label, onRadioClick, disabled } = props;
  const activate = (e) => {
    if (disabled) return;
    if (e.type === 'keydown') {
      if (e.key !== ' ' && e.key !== 'Enter') return;
      e.preventDefault();
    }
    onRadioClick(e);
  };
  return (
    <div
      className="radio-container"
      role="radio"
      aria-checked={selected}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : 0}
      onClick={activate}
      onKeyDown={activate}
    >
      <div className={`custom-radio-circle ${selected ? 'custom-radio-selected' : null}`}>
        {selected ? <div className="radio-selected" /> : false}
      </div>
      <div className="custom-radio-text">{label}</div>
    </div>
  );
}

RadioButton.propTypes = {
  selected: PropTypes.bool,
  label: PropTypes.string,
  onRadioClick: PropTypes.func,
  disabled: PropTypes.bool
};

RadioButton.defaultProps = {
  selected: false,
  label: 'Button',
  onRadioClick: () => console.log('Radio clicked'),
  disabled: false
};

export default RadioButton;
